import { ProfileView } from "@/modules/user/ProfileView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/profile/")({
    component: ProfileView,
});
